module.exports = __webpack_public_path__ + "static/limit-product-name-lines-e05d2fc127a2ae330b5bdf210734ba23.png";